























import {
    Vue,
    Component
} from "@/shared/vuepack";
import { useWexDebitCardsStore } from "@/shared/store/wexDebitCards";
import { WexDebitCardManageCardViewState } from "@/shared/types";
import WexDebitCardManageCardForm from "./WexDebitCardManageCardForm.vue";
import WexDebitCardDeactivateCardForm from "./WexDebitCardDeactivateCardForm.vue";
import WexDebitCardUpdatePinForm from "./WexDebitCardUpdatePinForm.vue";
import WexDebitCardConfirmDeactivatedCard from "./WexDebitCardConfirmDeactivatedCard.vue";
import WexDebitCardDeactivateCardAddressConfirm from "./WexDebitCardDeactivateCardAddressConfirm.vue";

@Component({
    components: {
        WexDebitCardManageCardForm,
        WexDebitCardDeactivateCardForm,
        WexDebitCardUpdatePinForm,
        WexDebitCardDeactivateCardAddressConfirm,
        WexDebitCardConfirmDeactivatedCard
    }
})
export default class WexDebitCardManageCardModal extends Vue {
    wexDebitCardsStore = useWexDebitCardsStore();

    WexDebitCardManageCardViewState = WexDebitCardManageCardViewState;

    get modalOpen () {
        return this.wexDebitCardsStore.wexManageCardModalOpen;
    }
    set modalOpen (value: boolean) {
        this.wexDebitCardsStore.setManageCardModalOpen(value);
    }
}
